export enum VisitCardButtonType {
  Cancel = 'Cancel',
  Confirm = 'Confirm',
  Confirmed = 'Confirmed',
  Reschedule = 'Reschedule',
}
